import React, { useEffect } from 'react'

import { View, ScrollView, StyleSheet, TouchableOpacity, Platform, Linking, ActivityIndicator } from 'react-native'

import delay from 'delay'

import {
  Text,
  Label,
  Description,
  Space,
  MenuList,
  StoredPaymentMethod,
  Anchor,
  CheckBox
} from '@sart/components'
import { colors, adaptive, typography, radius } from '@sart/styles'
import client, { useClient } from '@sart/client'
import { accountHolderFullname, accountHolderFullAddress } from '@sart/utilities'
import { useContent } from '@sart/content'
import {
  User,
  Mobile
} from '@sart/icons'
import { testID } from '@sart/utilities'

import AppConfig from '../Configuration'

export default function ProfileSummary(props) {
  const content = useContent()
  const { navigation } = props

  const {
    cache: {
      loading,
      storedPayment,
      customer,
      accounts,
      language
    } = {}
  } = useClient()
  const personalDetails = customer ? customer.personalDetails : undefined
  const homeAddress = customer ? customer.homeAddress : undefined
  const [changingPayment, setChangingPayment] = React.useState(false)
  const mobileAccount = accounts ? accounts.find(acc => acc.accountType === 'Mobile') : undefined
  console.log('mobile account is: ' + JSON.stringify(mobileAccount, null, 2))


  const emailLength = customer && customer.personalDetails && customer.personalDetails.emailAddress.length
  const communicationPreferences = customer?.communicationPreferences
  const customerEmailPref = communicationPreferences?.receiveEmail
  const customerSmsPref = communicationPreferences?.receiveSms

  const [marketingEmail, setMarketingEmail] = React.useState(customerEmailPref)
  const [marketingSms, setMarketingSms] = React.useState(customerSmsPref)
  const [changingCommunicationPreference, setChangingCommunicationPreference] = React.useState(false)

  function accountHolderFullAddressCommaSeparation(o) {
    if (!o) {
      return ''
    }
    const lines = [
      o.addressLine1,
      o.addressLine2,
      o.city,
      o.state,
      o.zip,
      o.country,
    ]

    return lines
      .filter(v => !!v)
      .join(', ')
  }

  async function handleChangePaymentMethod() {
    setChangingPayment(true)
    const flowStart = Date.now()
    try {
      console.log('[ChangePaymentMethod] flow started')
      const productsStart = Date.now()
      const updateProducts = await client.callApi('catalog', 'getUpdatePersonalDetails', [client.cache.catalogId])
      console.log(`[ChangePaymentMethod] getUpdatePersonalDetails took ${Date.now() - productsStart}ms`)
      const updatePaymentMethodProduct = updateProducts.find(product => product.productLegacyId === AppConfig.updatePaymentMethodProduct)


      const extendedData = {
        returnUrl: 'bikermobile://menu/profile/summary'
      }

      const checkoutStart = Date.now()
      const order = await client.checkoutCustomerProduct(updatePaymentMethodProduct, extendedData, {
        pollMode: 'aggressive'
      })
      console.log(`[ChangePaymentMethod] checkoutCustomerProduct took ${Date.now() - checkoutStart}ms`)

      if (order && order.status === 'successful' && order.message) {
        const openUrlStart = Date.now()
        Linking.openURL(order.message)
        console.log(`[ChangePaymentMethod] Linking.openURL dispatched in ${Date.now() - openUrlStart}ms`)
      }
    } catch (error) {
      console.log('Error changing payment method: ' + error)
    } finally {
      console.log(`[ChangePaymentMethod] flow finished in ${Date.now() - flowStart}ms`)
      setChangingPayment(false)
    }
  }

  async function handleChangeCommunicationPreference(communicationPreference, enabled) {
    console.log("handleChangeCommunicationPreference - pref: " + communicationPreference + ", enabled: " + enabled)
    setChangingCommunicationPreference(true)
    try {
      if (communicationPreference === "email") {
        setMarketingEmail(enabled)
        communicationPreferences.receiveEmail = enabled
      } else if (communicationPreference == "sms") {
        setMarketingSms(enabled)
        communicationPreferences.receiveSms = enabled
      }
      const modifyCustomerResult = await client.callApi('customer', 'modifyCommunicationPreference', [
        client.cache.customerId,
        communicationPreferences.id,
        communicationPreferences
      ])
    } catch (error) {
      console.log('Error changing communication preference: ' + error)
    } finally {
      setChangingCommunicationPreference(false)
    }
  }

  console.log('mobileAccount is: ' + JSON.stringify(mobileAccount, null, 2))

  return (
    <ScrollView style={styles.wrapper} contentContainerStyle={styles.container}>
      <Space height={16} />
      <Description style={styles.description}>{content.profile_summary.description}</Description>
      <Space height={24} />

      <View style={{ flexDirection: 'row', width: '100%', maxWidth: 600 }}>
        <View style={styles.titleColumn}>
          <Text style={styles.subtitle}>Name</Text>
          <Text style={styles.subtitle}>Email</Text>
          <Text style={styles.subtitle}>SIM ICCID</Text>
        </View>

        <View style={{ flexDirection: 'column', flex: 3, alignItems: 'flex-end', gap: 12 }}>
          <Text style={styles.displayValue}>{accountHolderFullname(personalDetails)}</Text>
          <Text style={styles.displayValue}>{personalDetails?.emailAddress || ''}</Text>
          {/*This needs to come from the service.lineidentifier*/}
          <Text style={styles.displayValue}>{mobileAccount?.services[0]?.serviceLegacyId || ''}</Text>
        </View>
      </View>

      <Space height={24} />

      <View style={{ width: '100%', maxWidth: 600, alignItems: 'left' }}>
        <Label>{content.register_details.marketingCommsConsent}</Label>
        <Space height={24} />
        <View style={styles.checkboxWrapper}>
          <CheckBox
            value={marketingEmail}
            onPress={() => handleChangeCommunicationPreference("email", !marketingEmail)}
            webSize={14}
            style={styles.checkbox}
            tintColors={{ true: colors.brightOrange, false: colors.white }}
            checkedColor={colors.brightOrange}
            borderColor={colors.brightOrange}
            disabledBorderColor={colors.white}
            tickColor={colors.white}
            disabled={changingCommunicationPreference}
            {...testID('SignUpDetailsMarketingEmail')}
          />
          <Space width={12} />
          <Label style={styles.checkboxLabel}>email</Label>
        </View>

        <Space height={6} />

        <View style={styles.checkboxWrapper}>
          <CheckBox
            value={marketingSms}
            onPress={() => handleChangeCommunicationPreference("sms", !marketingSms)}
            webSize={14}
            style={styles.checkbox}
            tintColors={{ true: colors.brightOrange, false: colors.white }}
            checkedColor={colors.brightOrange}
            borderColor={colors.brightOrange}
            disabledBorderColor={colors.softGray}
            tickColor={colors.white}
            disabled={changingCommunicationPreference}
            {...testID('SignUpDetailsMarketingSms')}
          />
          <Space width={12} />
          <Label style={styles.checkboxLabel}>SMS</Label>
        </View>
      </View>

      <Space height={48} />

      <View style={{ width: '100%', maxWidth: 600, alignItems: 'left' }}>
        <Anchor
          style={styles.link}
          title={changingPayment ? 'Changing Payment...' : 'Change Payment Method'}
          onPress={handleChangePaymentMethod}
          disabled={changingPayment}
        />
        {changingPayment && (
          <View style={{ marginLeft: 8 }}>
            <ActivityIndicator size="small" color={colors.brightOrange} />
          </View>
        )}
      </View>

    </ScrollView>
  )
}

const styles = StyleSheet.create({
  wrapper: {
    backgroundColor: colors.darkCharcoal
  },
  titleColumn: {
    flexDirection: 'column',
    alignItems: 'flex-start',
    flex: 1,
    gap: 12,
  },
  subtitle: {
    color: colors.brightOrange,
  },
  displayValue: {
    color: colors.white,
  },
  link: {
    color: colors.brightOrange,
    textDecorationLine: 'underline',
    fontWeight: '600' // Slightly bold
  },
  container: {
    paddingTop: 24,
    paddingBottom: 24,
    ...adaptive.wrapperPadding,
    backgroundColor: colors.darkCharcoal,
    flex: 1,
    width: '100%',
    alignItems: 'center'
  },
  description: {
    textAlign: 'center',
    ...typography.lightbold,
    color: colors.brightOrange
  },
  summary: {
    fontSize: 16,
    lineHeight: 24,
    color: colors.trivial,
    ...typography.medium
  },
  menuItemTitleStyle: {
    ...typography.lightbold
  },
  menuItemDescriptionStyle: {
    ...typography.medium
  },
  menuItemAnchorStyle: {
    ...typography.medium
  },
  inputStyle: {
    ...typography.book,
    paddingRight: 20,
    fontSize: 12,
  },
  footerStyle: {
    fontSize: 15,
    color: colors.trivial,
    marginTop: 8,
    ...typography.book
  },
  lineStyle: {
    color: 'red'
  },
  accountInformation: {
    alignItems: 'center'
  },
  information: {
    flexDirection: 'column',
    backgroundColor: colors.srGreyBackground,
    height: '15%',
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: 10
  },
  email: {
    flexDirection: 'row',
    alignItems: 'center'
  },
  emailText: {
    ...typography.lightbold,
    fontSize: 18,
    color: colors.brightOrange
  },
  emailTextLong: {
    ...typography.lightbold,
    fontSize: 16,
    color: colors.srGreen
  },
  number: {
    flexDirection: 'row',
    alignItems: 'center'
  },
  numberText: {
    ...typography.bold,
    fontSize: 28,
    color: colors.srGreen
  },
  groupContainer: {

  },
  borderContainer: {
    borderColor: colors.brightOrange,
    backgroundColor: colors.white,
    borderWidth: 1,
    borderRadius: 15,
    padding: 5,
    width: '90%',
    height: 72,
    alignSelf: 'center',
    justifyContent: 'center',
    overflow: 'hidden',
  },
  title: {
    color: colors.brightOrange,
    ...typography.lightbold,
    width: '90%',
    alignSelf: 'center',
    justifyContent: 'center',
    padding: 5
  },
  paymentContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    padding: 12,
    ...Platform.select({
      web: {
        padding: 8,
      },
    }),
    borderRadius: radius.smedium,
    backgroundColor: colors.white,
  },
  checkboxWrapper: {
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: 8
  },
  checkbox: {
    padding: 0,
    margin: 0
  },
  checkboxLabel: {
    ...typography.lightbold,
    color: colors.white,
    flex: 1,
    flexWrap: 'wrap'
  }
})
